<template>
    <div class="history-page">
        <div class="history-page__top">
            <p class="history-page__top-text">
                За время существования ИНК прошла большой путь от нефтяного стартапа до нефтегазохимического холдинга.
            </p>
            <p class="history-page__top-text">
                В числе перспективных направлений компания видит проекты по производству востребованной продукции с
                высокой добавленной стоимостью.
            </p>
            <p class="history-page__top-text">
                ИНК использует самые современные инструменты для рационального природопользования и ориентируется на
                лучшие практики в своей деятельности.
            </p>
        </div>
        <div class="history-page__timeline">
            <span class="history-page__year-base">20</span>
            <div class="timeline">
                <div
                    v-for="(slide, index) in history"
                    class="timeline-item"
                    :class="{'active': index === 0}"
                >
                    <div class="timeline-item__row">
                        <div class="timeline-item__year">
                            <span><p :class="{'history-page__year-base--first': index === 0}">{{
                                    splitYear(slide.year)[0]
                                }}</p>{{ splitYear(slide.year)[1] }}</span>
                        </div>

                        <div class="timeline-item__content html-content" v-html="slide.content"/>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { getCompanyHistory } from '@/api/company-history'

export default {
    name: 'history',
    data() {
        return {
            isAnimating: false,
            history: []
        }
    },
    methods: {
        init() {
            this
                .attach()
                .then(() => {
                    console.log('attached')

                    this.timelineJQueryPlugin()

                    $('.timeline').timelinev({
                        containerDivs: '.timeline-item',
                        dateDiv: '.timeline-item__year',
                        textDiv: '.timeline-item__content',
                        dateHtml: 'span',
                        textHtml: 'div',
                        dateActiveClass: '.active'
                    })
                })
        },
        timelineJQueryPlugin() {
            /* ----------------------------------
            jQuery Timelinev 1.1.0
            tested with jQuery v2.2.4

            Copyright 2017, Created by Xavier Raspall Gonzalez
            Free under the MIT license.
            http://www.opensource.org/licenses/mit-license.php
            ---------------------------------- */

            jQuery.fn.timelinev = function (options) {
                // plugin settings
                var settings = jQuery.extend({
                    timelineDiv: $(this),
                    containerDivs: '.timelineCont',
                    dateDiv: '.date',
                    textDiv: '.text',
                    dateHtml: 'h2',
                    textHtml: 'p',
                    dateActiveClass: '.active',
                    datesSpeed: '750'
                }, options)

                $(function () {
                    // setting variables
                    var divsCont = settings.timelineDiv.find(settings.containerDivs)
                    var datesCont = divsCont.find(settings.dateDiv + ' ' + settings.dateHtml)
                    var dates = parseFecha(datesCont)
                    var dateActive = dates.indexOf($(settings.dateActiveClass + ' ' + settings.dateDiv + ' ' + settings.dateHtml).html())

                    var divHeight = divsCont.outerHeight()
                    var isAnimating = false
                    var dragStep = 64
                    var dragActivate = 12
                    var dragState = {
                        active: false,
                        pointerId: null,
                        lastY: 0,
                        startY: 0,
                        accum: 0,
                        captured: false
                    }
                    var $dragRoot = settings.timelineDiv.closest('.history-page__timeline')
                    if (!$dragRoot.length) {
                        $dragRoot = settings.timelineDiv
                    }
                    var dragRootEl = $dragRoot.get(0)

                    // Show date active
                    if (dateActive > 0) {
                        // eslint-disable-next-line no-unmodified-loop-condition
                        for (i = 0; i < dateActive - 1; i++) {
                            $(divsCont[i]).css('margin-top', -divHeight)
                        }
                    }

                    function isTimelineInteractive() {
                        return window.outerWidth > 600
                    }

                    function goToPrevYear() {
                        if (isAnimating || dateActive === 0) {
                            return
                        }

                        $dragRoot.addClass('is-interacted')
                        isAnimating = true
                        divsCont.removeClass('active')
                        $(divsCont[(dateActive - 1)]).addClass('active')
                        if (dateActive <= 0) {
                            $('.history-page__year-base')
                                .animate(
                                    {'opacity': 0},
                                    {duration: 0}
                                )
                            $('.history-page__year-base').css('color', '')
                            $('.history-page__year-base--first').css('opacity', 1)
                        }
                        incrementDate()
                        dateActive--
                        setTimeout(function () {
                            isAnimating = false
                        }, settings.datesSpeed)
                    }

                    function goToNextYear() {
                        if (isAnimating || dateActive === dates.length - 1) {
                            return
                        }

                        $dragRoot.addClass('is-interacted')
                        isAnimating = true
                        divsCont.removeClass('active')
                        $(divsCont[(dateActive + 1)]).addClass('active')

                        if (dateActive === 0) {
                            $('.history-page__year-base')
                                .animate(
                                    {'opacity': 1},
                                    {duration: 'settings.datesSpeed'}
                                )
                            $('.history-page__year-base').css('color', 'var(--color-primary)')
                            $('.history-page__year-base--first').css('opacity', 0)
                        }

                        if (dateActive !== divsCont.length - 1) {
                            decrementDate()
                        }

                        dateActive++

                        setTimeout(function () {
                            isAnimating = false
                        }, settings.datesSpeed)
                    }

                    function onDragMove(clientY) {
                        if (isAnimating) {
                            dragState.lastY = clientY
                            dragState.accum = 0
                            return
                        }

                        dragState.accum += dragState.lastY - clientY
                        dragState.lastY = clientY

                        if (dragState.accum >= dragStep) {
                            goToNextYear()
                            dragState.accum = 0
                        } else if (dragState.accum <= -dragStep) {
                            goToPrevYear()
                            dragState.accum = 0
                        }
                    }

                    function stopDrag(event) {
                        if (!dragState.active) {
                            return
                        }

                        if (event && dragState.pointerId !== null && event.pointerId !== dragState.pointerId) {
                            return
                        }

                        if (dragState.pointerId !== null && dragRootEl.hasPointerCapture(dragState.pointerId)) {
                            dragRootEl.releasePointerCapture(dragState.pointerId)
                        }

                        dragState.active = false
                        dragState.pointerId = null
                        dragState.accum = 0
                        dragState.captured = false
                        $dragRoot.removeClass('is-dragging')
                    }

                    function onPointerDown(event) {
                        if (!isTimelineInteractive()) {
                            return
                        }

                        var isLmb = event.pointerType === 'mouse' && event.button === 0
                        var isTouch = event.pointerType === 'touch' || event.pointerType === 'pen'
                        if (!isLmb && !isTouch) {
                            return
                        }

                        dragState.active = true
                        dragState.pointerId = event.pointerId
                        dragState.lastY = event.clientY
                        dragState.startY = event.clientY
                        dragState.accum = 0
                        dragState.captured = false
                    }

                    function onPointerMove(event) {
                        if (!dragState.active || event.pointerId !== dragState.pointerId) {
                            return
                        }

                        if (!dragState.captured) {
                            if (Math.abs(event.clientY - dragState.startY) < dragActivate) {
                                return
                            }
                            dragState.captured = true
                            dragRootEl.setPointerCapture(event.pointerId)
                            $dragRoot.addClass('is-dragging')
                        }

                        event.preventDefault()
                        onDragMove(event.clientY)
                    }

                    // Колесо мыши
                    settings.timelineDiv.bind('mousewheel DOMMouseScroll', function (event) {
                        if (!isTimelineInteractive()) {
                            return
                        }

                        event.preventDefault()

                        if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
                            goToPrevYear()
                        }

                        if (event.originalEvent.wheelDelta < 0 || event.originalEvent.detail > 0) {
                            goToNextYear()
                        }
                    })

                    // Перетягивание ЛКМ и пальцем
                    dragRootEl.addEventListener('pointerdown', onPointerDown)
                    dragRootEl.addEventListener('pointermove', onPointerMove, {passive: false})
                    dragRootEl.addEventListener('pointerup', stopDrag)
                    dragRootEl.addEventListener('pointercancel', stopDrag)

                    // Parse dates
                    function parseFecha(fechasHTML) {
                        var arrayDates = []
                        fechasHTML.each(function () {
                            var singleDate = $(this).html()
                            arrayDates.push(singleDate)
                        })
                        return arrayDates
                    }

                    // Increment
                    function incrementDate() {
                        $(divsCont[(dateActive)]).animate({'margin-top': 0}, {
                            queue: true,
                            duration: 'settings.datesSpeed'
                        })
                        $(divsCont[(dateActive - 1)]).animate({'margin-top': 0}, {
                            queue: true,
                            duration: 'settings.datesSpeed'
                        })
                    }

                    // Decrement
                    function decrementDate() {
                        divHeight = divsCont.outerHeight()

                        $(divsCont[dateActive]).animate({'margin-top': '-' + divHeight}, {
                            queue: true,
                            duration: 'settings.datesSpeed'
                        })
                        $(divsCont[dateActive - 1]).animate({'margin-top': '-' + divHeight}, {
                            queue: true,
                            duration: 'settings.datesSpeed'
                        })
                    }
                })
            }
        },
        attach() {
            // eslint-disable-next-line one-var
            let attached = false,
                loaded = false,
                error = false,
                stack = []

            return new Promise((resolve, reject) => {
                if (!attached) {
                    const script = document.createElement('script')
                    script.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.2.1/jquery.min.js')
                    script.setAttribute('async', '')
                    document.head.appendChild(script)

                    script.onload = () => {
                        resolve()
                        loaded = true
                        stack.forEach(cb => {
                            cb[0]()
                        })
                        stack = []
                    }
                    script.onerror = (err) => {
                        reject(err)
                        loaded = true
                        error = true
                        stack.forEach(cb => {
                            cb[1]()
                        })
                        stack = []
                    }
                    attached = true
                }

                if (error) reject(error)

                if (loaded) {
                    resolve()
                } else {
                    stack.push([resolve, reject])
                }
            })
        },
        splitYear(year) {
            const yearString = year.toString();
            const firstPart = yearString.slice(0, 2);
            const secondPart = yearString.slice(2);

            return [firstPart, secondPart];
        },
        async loadHistory() {
            try {
                const data = await getCompanyHistory()
                this.history = Array.isArray(data) ? data : []
            } catch (e) {
                this.history = []
            }
        }
    },
    async mounted() {
        await this.loadHistory()
        await this.$nextTick()
        this.init()
    }
}


</script>

<style lang="scss">
.history-page {
    &__top {
        max-width: 67%;

        @include breakpoint(v-tablet){
            max-width: 100%;
        }

        &-text{
            @include typo-level(L);
        }
    }

    &__timeline {
        height: 512px;
        overflow: hidden;
        @include margin-level(top, L);
        position: relative;
        user-select: none;
        touch-action: none;
        cursor: grab;

        &.is-dragging {
            cursor: grabbing;

            a {
                cursor: grabbing;
            }
        }

        &.is-dragging,
        &.is-interacted {
            .timeline-item__year {
                animation: none;
            }
        }
    }

    &__year-base {
        position: absolute;
        top: 75px;
        @include typo-level(5XL);
        color: var(--color-table-text-light);
        opacity: 0;

        @include breakpoint(laptop){
            top: 54px;
        }

        @include breakpoint(tablet){
            top: 66px;
        }

        @include breakpoint(v-tablet){
            top: 72px;
        }
    }
}

.timeline {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    width: 100%;

    &-item {
        width: 100%;
        min-height: 150px;

        &.active & {
            &__year {
                &::before {
                    background: var(--color-primary);
                }

                & span {
                    color: var(--color-primary);
                }
            }

            &__content {
                opacity: 1;
            }
        }

        &__row {
            position: relative;
            min-height: 320px;
            display: flex;
        }

        &__content {
            position: absolute;
            left: 375px;
            top: 50%;
            padding-left: 126px;
            transform: translate(0, -50%);
            opacity: 0;
            transition: opacity .4s ease-in-out;

            & ul {
                margin-bottom: 0;
            }
            & a{
                font-weight: 600;
                cursor: pointer;
            }
        }

        &__year {
            border-right: 1px solid #CCCCCC;
            position: relative;
            width: 375px;
            text-align: left;
            display: flex;
            animation: history-year-hint 1.8s ease-in-out 0.6s 2;

            &:before {
                content: '';
                background: var(--color-table-text-light);
                position: absolute;
                left: 100%;
                top: 50%;
                border-radius: 100%;
                transform: translate(-50%, -50%);
                border: 24px solid #fff;
                width: 68px;
                height: 68px;
            }

            & span {
                margin: auto 0;
                @include typo-level(5XL);
                color: var(--color-table-text-light);

                p {
                    display: inline;
                    opacity: 0;

                    &.history-page__year-base--first {
                        opacity: 1;
                    }
                }
            }
        }
    }
}

@keyframes history-year-hint {
    0%,
    100% {
        transform: translateY(0);
    }

    35% {
        transform: translateY(-10px);
    }

    55% {
        transform: translateY(4px);
    }

    72% {
        transform: translateY(-5px);
    }
}

@include breakpoint(tablet) {
    .history {
        &-page{
            &__timeline{
                height: 400px;
            }
        }
    }

    .timeline-item {
        min-height: 200px;

        &__row {
            height: 100%;
        }

        &__year {
            width: 200px;
            display: flex;
            align-items: center;

            &:before {
                border-width: 12px;
                width: 44px;
                height: 44px;
            }

        }

        &__content {
            left: 200px;
            padding-left: 48px;
        }
    }
}

@include breakpoint(mobile) {
    .history-page {
        &__timeline{
            height: auto;
            touch-action: auto;
            user-select: auto;
            cursor: auto;
        }

        &__year-base {
            display: none !important;
        }
    }
    .timeline-item {
        margin-top: 0 !important;
        min-height: 0;

        &:not(:last-of-type) {
            @include margin-level(bottom, 2XL);
        }

        &__row {
            flex-wrap: wrap;
            min-height: unset;
            height: auto;
        }

        &__year {
            flex-shrink: 0;
            width: 100%;
            border: none;
            margin-bottom: 24px;
            animation: none;

            &:before {
                display: none;
            }

            span {
                position: relative;
                margin: 0;
                padding-left: 28px;
                color: var(--color-primary) !important;

                &:before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 50%;
                    width: 12px;
                    height: 12px;
                    background-color: var(--color-primary);
                    margin-top: -6px;
                    border-radius: 50%;
                }

                p {
                    opacity: 1 !important;
                }
            }
        }

        &__content {
            position: relative;
            left: auto;
            top: auto;
            margin-top: 0;
            padding: 0;
            width: 100%;
            transform: unset;
            opacity: 1;
        }

    }
}

@media screen and (max-height: 576px) and (max-width: 1024px){
    .history-page {
        &__timeline{
            height: auto;
            touch-action: auto;
            user-select: auto;
            cursor: auto;
        }

        &__year-base {
            display: none !important;
        }
    }
    .timeline-item {
        margin-top: 0 !important;
        min-height: 0;

        &:not(:last-of-type) {
            @include margin-level(bottom, 2XL);
        }

        &__row {
            flex-wrap: wrap;
            min-height: unset;
            height: auto;
        }

        &__year {
            flex-shrink: 0;
            width: 100%;
            border: none;
            margin-bottom: 24px;
            animation: none;

            &:before {
                display: none;
            }

            span {
                position: relative;
                margin: 0;
                padding-left: 28px;
                color: var(--color-primary) !important;

                &:before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 50%;
                    width: 12px;
                    height: 12px;
                    background-color: var(--color-primary);
                    margin-top: -6px;
                    border-radius: 50%;
                }

                p {
                    opacity: 1 !important;
                }
            }
        }

        &__content {
            position: relative;
            left: auto;
            top: auto;
            margin-top: 0;
            padding: 0;
            width: 100%;
            transform: unset;
            opacity: 1;
        }

    }
}

</style>
